export enum TabsItemFiles {
    ALL_FILES = "ALL_FILES",
    USERS_WITH_FILES = "USERS_WITH_FILES",
}

export enum TabsItemFilesDeatil {
    FILE = "FILE",
    PERMISSIONS = "PERMISSIONS",
}